import React from "react";
import {
  Avatar,
  Box,
  Button,
  Flex,
  Stack,
} from "@chakra-ui/core";
import Logo from "../../elements/Logo";
import { FaRegBell, FaPlus } from "react-icons/fa";
import { GiHamburgerMenu } from "react-icons/gi";

/** The upper most part of the dashboard (Logo, main menu ...) */

const DasboardHeaderMockup = (props) => {

  return (
    <>
      <Box
        pos="relative"
        top="0"
        zIndex="4"
        left="0"
        right="0"
        width="100%"
        py="15px"
        bg="primary.600"
        borderTopLeftRadius="5px"
        borderTopRightRadius="5px"
      >
        <Flex align="center" justify="center" w="100%">
          <Box maxWidth="1280px" w="100%" h="100%" >
            <Flex
              size="100%"
              align="center"
              justifyContent="space-between"
              borderBottomWidth="1px"
              borderBottomColor="#47475F"
              pb="12px"
            >
              <Stack alignItems="center" isInline>
                <Box
                  minWidth="120px"
                  d="block"
                  aria-label="Dotpay logo |Back to homepage"
                >
                  <Logo color="white" />
                </Box>
                <Stack
                  display={["none", "none", "block", "block"]}
                  isInline
                  spacing={2}
                  align="center"
                >
                  <Button
                    size="sm"
                    cursor="default"
                    bg="primary.700"
                    _hover={{
                      bg: "none",
                    }}
                    color="primary.100"
                  >
                    ORDERS
                  </Button>
                  <Button
                    size="sm"
                    cursor="default"
                    bg="none"
                    _hover={{
                      bg: "none",
                    }}
                    color="primary.100"
                  >
                    CUSTOMERS
                  </Button>
                  <Button
                    size="sm"
                    cursor="default"
                    bg="none"
                    _hover={{
                      bg: "none",
                    }}
                    color="primary.100"
                  >
                    PAYOUTS
                  </Button>
                </Stack>
              </Stack>

              <Stack mx="20px" alignItems="center" spacing={2} isInline>
                <Box as={FaPlus} color="primary.100" />
                <Box color="primary.100" size="18px" as={FaRegBell} />
                <Avatar
                  borderWidth="1px"
                  bg="none"
                  size="xs"
                  name="Dan Abrahmov"
                  src="https://ca.slack-edge.com/ESZCHB482-W012QNQMXB6-8b9c4a81bdcd-512"
                />
                {/** This is for mobile menu */}
                <Box
                  display={["block", "block", "none", "none"]}
                  as={GiHamburgerMenu}
                  color="primary.100"
                />
              </Stack>
            </Flex>
          </Box>
        </Flex>
      </Box>
    </>
  );
};

export default DasboardHeaderMockup;
